import omitUndefined from 'utils/omitUndefined';
import { OpenSubmissionsStreamElement } from 'communication/types/openSubmissions/OpenSubmissionsElement';
import { StreamElementType } from 'communication/types/StreamElementType';
import { OpenSubmissionsStreamItem } from './OpenSubmissionsStreamDataState';

export function mapToOpenSubmissionsStreamItemFromElement(
    from: OpenSubmissionsStreamElement<StreamElementType>
): OpenSubmissionsStreamItem {
    return omitUndefined({
        _i: from._i,
        limitPrice: from.px,
        parentOrderId: from.po,
        id: from.ordid,
        averageExecutionPrice: from.avgpx,
        isIOI: from.isIOI,
        executedQuantity: from.cumqty,
        executionVenueName: from.destName,
        orderQty: from.ordqty,
        remainingQty: from.remqty,
        status: from.ordstat,
        updateTimeEpoch: from.time,
        marketStatus: from.ms,
        shouldRemove: from.shouldRemove,
        executionVenueCode: from.destCode,
        executionVenueType: from.destType,
        actor: from.actor,
        pegType: from.pegTypeName,
    });
}
